import type { FinancialCompleteness } from '../../types/order';

export function canShowOrderFinancialCompletenessStatus(
  canViewCustomerSalePrices: boolean,
  financialCompleteness: FinancialCompleteness | undefined,
): boolean {
  return Boolean(canViewCustomerSalePrices && financialCompleteness?.status === 'PENDING');
}

export function canShowOrderSalePricesIncompleteHint(
  canViewCustomerSalePrices: boolean,
  financialCompleteness: FinancialCompleteness | undefined,
): boolean {
  return Boolean(
    canViewCustomerSalePrices
      && financialCompleteness?.missing?.includes('CUSTOMER_SALE_PRICES')
  );
}
